<template>
    <div class="third-element-container">
        <div class="card-third" v-for="(item, index) in thirdThreeList" :key="index"
            :class="{ even: index % 2 === 0, odd: index % 2 !== 0 }">
            <div class="card-third-content-left">
                <h2>{{ item.bigTitle }}</h2>
                <div class="sub_title">{{ item.subTitle1 }}</div>
                <p>{{ item.content1 }}</p>
                <div class="sub_title">{{ item.subTitle2 }}</div>
                <p>{{ item.content2 }}</p>
                <div class="sub_title">{{ item.subTitle3 }}</div>
                <p>{{ item.content3 }}</p>
            </div>
            <div class="card-third-content-right">
                <img :src="item.img" alt="">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            thirdThreeList: [
                {
                    bigTitle: 'For scholars:',
                    subTitle1: 'Live citation tracking',
                    subTitle2: 'Enhanced visibility',
                    subTitle3: 'Smarter literature discovery',
                    content1: 'Stay informed with real-time updates when your work is cited, so they don’t need no more waiting for periodic reports.',
                    content2: 'Showcase your paper’s contribution using normalized, context-aware metrics to reflect true impact beyond raw numbers.',
                    content3: 'Receive curated suggestions of relevant, high-quality research to support your next study or collaboration.',
                    img: require('@/assets/images/services/thirdThree1.png'),
                },
                {
                    bigTitle: 'For publishers and journals:',
                    subTitle1: 'Enriched article pages',
                    subTitle2: 'Matured authors engagement',
                    subTitle3: 'Effortless integration',
                    content1: 'Integrate dynamic citation displays, contribution scores, and recommended reads.',
                    content2: 'Attract high-caliber submissions by offering transparency, recognition, and modern impact tools.',
                    content3: 'A lightweight, API-friendly plug-in that seamlessly enhances your existing infrastructure.',
                    img: require('@/assets/images/services/thirdThree2.png'),
                },
                {
                    bigTitle: 'For readers:',
                    subTitle1: 'Contextual recommendations',
                    subTitle2: 'Trustworthy citation and recommendation signals',
                    subTitle3: 'Time-saving exploration',
                    content1: 'Instantly see related research aligned with your interests powered by smart filtering and contribution relevance.',
                    content2: 'Know which articles are truly influential, not just frequently cited, thanks to normalized impact scores.',
                    content3: 'Navigate research landscapes more efficiently with personalized content curation and intelligent suggestions.',
                    img: require('@/assets/images/services/thirdThree3.png'),
                },
            ]
        }
    },
}
</script>

<style lang="scss" scoped>
.third-element-container {
    max-width: 1200px;
    margin: 0 auto;

}

.card-third {
    padding: 20px 40px;
    display: flex;
    align-items: center;

    h2{
        font-size: 30px;
        margin-bottom: 6px;
        line-height: 42px;
        font-weight: bold;
    }

    p{
        line-height: 28px;

    }
    .sub_title{
        color: #333;
        font-size: 20px;
        line-height: 28px;
        font-weight: bold;

    }
    &.even {
        background-color: #fff;
        .card-third-content-right{
            text-align: center;
        }
       
    }

    &.odd {
        background-color: transparent;
        flex-direction: row-reverse;

    }
}

.card-third-content-left {
    flex: 1;
}

.card-third-content-right {
    flex: 1;

    img {
        width: 60%;
    }
}
</style>